/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-unused-state */
/* eslint-disable camelcase */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';

import Select2, { DataSelect2 } from 'wdna-select2';
import DatePicker from 'wdna-date-selector';

import { UserDO } from 'wdna-components';
import { GridApi, RowDataChangedEvent, GridReadyEvent, ICellRendererParams } from 'wdna-grid-table/lib/types';
import Table, { TableButtonsConfig } from 'wdna-components/lib/table/Table';
import { TabConfig, addTab, removeTab } from 'wdna-components/lib/tabs';
import { messageInfo, messageError, messageBoxWarning, messageBoxInfo } from 'wdna-components/lib/helpers/notification';
import { getErrorMessage } from 'wdna-components/lib/helpers/response';
import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

import SensorsEdit from '../forms/sensors/Edit';
import Graphs from './Graphs';
import Readings from './Readings';

import { sensor, SensorListDO } from '../../requests';

type Props = unknown;

interface State {
  loading: boolean;
  update: string;
  marked: number;
  id_src: string;
  id_dst: string;
  modalContent: string;
  showGrid: boolean;
  showSelector: boolean;
  showNominal: boolean;
  showMigrateRegister: boolean;
  date: Date[];
  flatpickrMode: string;
  groupDateTime: string;
  dateIni: string;
  timeIni: string;
  dateEnd: string;
  timeEnd: string;

  status?: string;

  data: SensorListDO[];
}

export default class Sensors extends React.Component<Props, State> {
  private tabId: any;
  private buttons: TableButtonsConfig;
  private mounted: boolean;
  private gridApi: GridApi | undefined;

  public constructor(props: Props) {
    super(props);

    const dIni: Date = new Date();
    dIni.setDate(dIni.getDate() - 2);
    const dEnd: Date = new Date();

    this.tabId = window.getStr();
    this.mounted = false;
    this.buttons = {
      // toolbar
      add: true,
      custom: [true, true],
      // actions
      edit: true,
      duplicate: true,
      del: true,
      graph: true,
      list: true,
      toggleItem: true,
      labels: {
        graph: 'Readings',
        list: 'Readings',
        custom: ['Readings', 'Nominal Plan', 'Migrate Register']
      }
    };

    this.state = {
      loading: false,
      update: window.getStr(),
      data: [],
      marked: 0,
      id_src: '',
      id_dst: '',
      modalContent: '',
      showGrid: false,
      showSelector: false,
      showNominal: false,
      showMigrateRegister: false,
      date: this.initialDates(),
      flatpickrMode: 'range',
      groupDateTime: '24h',
      dateIni: moment(dIni).add(1, 'days').format('YYYY-MM-DD'),
      timeIni: '00:00',
      dateEnd: moment(dEnd).add(1, 'days').format('YYYY-MM-DD'),
      timeEnd: '00:00',
    };
  }

  public componentDidMount = (): void => {
    this.mounted = true;
    this.load();
  };

  public shouldComponentUpdate = (nextProps: Props, nextState: State): boolean => {
    return this.state.update !== nextState.update;
  }

  public componentWillUnmount = (): void => {
    this.mounted = false;
  };

  public load = (): void => {
    this.loadingStart();
    sensor<SensorListDO[]>('list')
      ?.then((resp: SensorListDO[]) => {
        if (this.mounted) {
          this.setState({
            data: resp,
          });
        }
      })
      .catch((error: any) => {
        messageError('Error', getErrorMessage(error));
      })
      .finally(() => {
        this.loadingFinish();
      });
  };

  public initialDates = (): Date[] => {
    const today: Date = new Date();
    const twoDaysBefore: Date = moment().add(-2, 'days').toDate();
    return [twoDaysBefore, today];
  };

  public loadingStart = (): void => {
    this.setState({
      update: window.getStr(),
      loading: true,
    });
  };

  public loadingFinish = (): void => {
    this.setState({
      update: window.getStr(),
      loading: false,
    });
  };

  public loadTab = (rowId: number, duplicate: boolean): void => {
    const tabId: string = 'SE';
    let title: string = rowId ? `Sensor Edit: ${rowId}` : 'Sensor New';
    if (duplicate) title = `Sensor Duplicate: ${rowId}`;

    window.store.dispatch(removeTab(tabId));
    const tabData: TabConfig = {
      id: tabId,
      active: true,
      title,
      component: SensorsEdit,
      props: {
        rowId,
        tabId: this.tabId,
        report: 'SENSORS',
        title: 'Sensors',
        notify: this.notify,
        sensorList: this.state.data,
        duplicate
      },
    };
    window.store.dispatch(addTab(tabData));
  };

  public showModalUpdate = (): void => {
    this.setState({
      update: window.getStr(),
      showSelector: true,
    });
  };

  public onClose1 = (): void => {
    this.setState({
      update: window.getStr(),
      showSelector: false,
    });
  };

  public onClose2 = (): void => {
    this.setState({
      update: window.getStr(),
      showNominal: false,
    });
  };

  public onClose3 = (): void => {
    this.setState({
      update: window.getStr(),
      showMigrateRegister: false,
    });
  };

  public resetModal = (): void => {
    this.setState({
      update: window.getStr(),
      status: '',
      marked: 0,
    });
  };

  public notify = (): void => {
    this.load();
  };

  public onEdit = (value: SensorListDO): void => {
    window.store.dispatch(removeTab('SE'));
    const rowId: number = value.id;
    const duplicate: boolean = false;
    setTimeout(() => {
      this.loadTab(rowId, duplicate);
    }, 0);
  };

  public onDuplicate = (value: SensorListDO): void => {
    window.store.dispatch(removeTab('SE'));
    const rowId: number = value.id;
    const duplicate: boolean = true;
    setTimeout(() => {
      this.loadTab(rowId, duplicate);
    }, 0);
  };

  public onDelete = (value: SensorListDO): void => {
    messageBoxWarning('Delete', `Do you want to delete this register ${value.code} - ${value.name}?`, () => {
      this.loadingStart();
      sensor('del', String(value.id))
        ?.then(() => {
          messageInfo('Success', 'Register successfully deleted', 5000);
          this.load();
        })
        .catch((error: any) => {
          messageError('Error', getErrorMessage(error));
        })
        .finally(() => {
          this.loadingFinish();
        });
    });
  };

  public onGraph = (value: SensorListDO): void => {
    window.store.dispatch(removeTab('GRH'));
    const id: number = value.id;
    const code: string = value.code;
    setTimeout(() => {
      this.loadGraph(id, code);
    }, 0);
  };

  public loadGraph = (id: number, code: string): void => {
    const tabId: string = 'GRH';
    const title: string = id ? `Sensor Graphs: ${id} - ${code}` : 'Total Graphs';
    const tabData: TabConfig = {
      id: tabId,
      active: true,
      title,
      component: Graphs,
      props: {
        rowId: id,
        code,
        report: 'SENSORS GRAPHS',
        title: 'Sensors Graphs',
        tabId: this.tabId,
      },
    };
    window.store.dispatch(addTab(tabData));
  };

  public onList = (value: SensorListDO): void => {
    window.store.dispatch(removeTab('RED'));
    const id: number = value.id;
    const code: string = value.code;
    setTimeout(() => {
      this.loadList(id, code);
    }, 0);
  };

  public loadList = (id?: number, code?: string): void => {
    const tabId: string = 'RED';
    const title: string = id ? `Sensor Reads: ${id} - ${code}` : 'Total Reads';
    const tabData: TabConfig = {
      id: tabId,
      active: true,
      title,
      component: Readings,
      props: {
        code,
        rowId: id,
        report: 'SENSOR READS',
        title: 'Sensor Reads',
        tabId: this.tabId,
      },
    };
    window.store.dispatch(addTab(tabData));
  };

  public onCustom1 = (): void => {
    window.store.dispatch(removeTab('RED'));
    setTimeout(() => {
      this.loadList();
    }, 0);
  };

  public onCustom2 = (): void => {
    this.setState({
      update: window.getStr(),
      showNominal: true,
    });
  };

  public onCustom3 = (): void => {
    this.setState({
      update: window.getStr(),
      showMigrateRegister: true,
    });
  };

  public rowDataChanged = (_event: RowDataChangedEvent): void => {
    this.setState({
      update: window.getStr(),
      showGrid: true,
    });
  };

  public handleSelect = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const { value, name } = e.target;
    this.setState((prevState: State) => ({
      ...prevState,
      update: window.getStr(),
      [name]: value,
    }));
  };

  public countSelected = (): void => {
    let marked: number = 0;
    if (this.gridApi) {
      marked = this.gridApi.getSelectedNodes().length;
    }
    this.setState({
      update: window.getStr(),
      marked,
    });
  };

  public onSave = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    messageBoxInfo('Update', 'Are you sure you want change status the selected sensors?', () => {
      this.bulkActivation(this.state.status);
      this.onClose1();
      this.resetModal();
    });
  };

  public alertsCellRenderer = (params: ICellRendererParams): React.ReactNode => {
    if (params.data.status === 'ON_AIR') {
      let { value } = params;
      const result: JSX.Element[] = [];
      if (value !== null && String(value).length > 4) {
        value = String(value);
        result.push(<i className="fa fa-circle" style={{ color: (value[0] === '0' ? 'green' : 'red') }} title="TIMESTAMP" />);
        result.push(<i className="fa fa-circle" style={{ color: (value[1] === '0' ? 'green' : 'red') }} title="FIRE" />);
        result.push(<i className="fa fa-circle" style={{ color: (value[2] === '0' ? 'green' : 'red') }} title="BATTERY" />);
        result.push(<i className="fa fa-circle" style={{ color: (value[3] === '0' ? 'green' : 'red') }} title="RSSI" />);
        result.push(<i className="fa fa-circle" style={{ color: (value[4] === '0' ? 'green' : 'red') }} title="MALFUNCTION" />);
      }

      return <div>{result}</div>;
    }

    return '';
  }

  public notifyNcCellRenderer = (params: ICellRendererParams): React.ReactNode => {
    if (params.data.status === 'ON_AIR') {
      let { value } = params;
      const { field } = params.colDef;

      const colorStyle: any = { color: params.data && params.data[field || ''] ? 'red' : 'green' };
      value = params.data && <i className="fa fa-circle" style={colorStyle} />;

      return value;
    }

    return '';
  }

  public bulkActivation = (status: any): void => {
    if (this.gridApi) {
      const selectedNodes: any[] = this.gridApi.getSelectedNodes();
      const data: SensorListDO[] = selectedNodes.map((row: any) => { return row.data.id; });

      this.loadingStart();
      sensor('update', undefined, data, { params: { status } })
        ?.then((resp: any) => {
          messageInfo('Success', resp.message, 5000);
          this.load();
        })
        .catch((error: any) => {
          messageError('Error', getErrorMessage(error));
        })
        .finally(() => {
          this.loadingFinish();
        });
    }
  };

  public dateCellRenderer = (params: ICellRendererParams): any => {
    let { value } = params;
    if (value) {
      [value] = value.split(' ');
    }
    return value;
  }

  public onGridReady = (event: GridReadyEvent): void => {
    // map the api
    this.gridApi = event.api;
  };

  public convertNumber = (): void => {
    if (this.state.data !== undefined) {
      for (let i: number = 0; i < this.state.data.length; i++) {
        Number(this.state.data[i].code);
      }
    }
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    const { name, value, type, checked } = (e as React.ChangeEvent<HTMLInputElement>).target;
    if (type === 'checkbox') {
      this.setState((prevState: State) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      this.setState((prevState: State) => ({
        ...prevState,
        [name]: value,
      }));
    }
  }

  public handleDatePickerChanges = (config: any, dateKey: string = 'date'): any => {
    const date: Date[] = config.getDates();
    this.setState((prevState: State) => ({
      ...prevState,
      [dateKey]: date,
      flatpickrMode: config.getMode(),
    }));
    const preDataIni: Date = date[0];
    const newDataIni: string = moment(preDataIni).format('YYYY-MM-DD');
    this.setState({ dateIni: newDataIni });
    const preDataEnd: Date = date[1];
    if (this.state.flatpickrMode === 'range') {
      const newDataEnd: string = moment(preDataEnd).format('YYYY-MM-DD');
      this.setState({ dateEnd: newDataEnd });
    } else {
      const copyData: string = moment(newDataIni).add(1, 'days').format('YYYY-MM-DD');
      this.setState({ dateEnd: copyData });
    }
  };

  public migrateRegisters = async (): Promise<void> => {
    this.loadingStart();
    try {
      const req: Record<string, any> = {};
      req.id_src = this.state.id_src;
      req.id_dst = this.state.id_dst;
      req.from = this.state.date[0];
      req.to = this.state.date[1];
      const idSensorSrc: string = this.state.id_src;
      const idSensorDst: string = this.state.id_dst;
      const sensorInfoSrc: any = await sensor('get', idSensorSrc);
      const sensorInfoDst: any = await sensor('get', idSensorDst);
      const typeSensorIdSrc: number = sensorInfoSrc.typeSensor && sensorInfoSrc.typeSensor.id;
      const typeSensorIdDst: number = sensorInfoDst.typeSensor && sensorInfoDst.typeSensor.id;
      if (typeSensorIdSrc === typeSensorIdDst) {
        const res: any = await sensor('copy', undefined, req);
        this.setState({
          modalContent: res,
        });
        messageInfo('Success', 'Transfer register OK', 5000);
      } else {
        messageError('Error', 'Typse sensor is diferent');
      }
    } catch (error) {
      messageError('Error', getErrorMessage(error));
    }
    this.loadingFinish();
  }

  public render(): JSX.Element {
    const { loading, showSelector, showNominal, showGrid, showMigrateRegister, date, flatpickrMode, groupDateTime, id_src, id_dst, data, modalContent, marked } = this.state;
    const user: UserDO = _.get(window.store.getState(), ['user', 'user']);
    const userIsSuper: boolean = (user.superuser === 1);
    if (userIsSuper && this.buttons.custom) this.buttons.custom[2] = true;

    this.convertNumber();

    const columnAlias: Record<string, string> = {
      selectedRow: ' ',
      id: 'ID',
      code: 'Code',
      status: 'Status',
      name: 'Name',
      description: 'Description',
      dateLast: 'Last-DATE',
      ipLast: 'Last-ADRS',
      gatewayLast: 'Last-GTWY',
      notifyNc: 'NCX',
      update: 'Update',
      companyName: 'Company',
      locationName: 'Location',
      firmwareVer: 'Firmware',
      typeSensorName: 'Sensor type',
      alarm: 'ALA',
      adjusted: 'ADJ',
      alerts: 'Alerts',
      latitude: 'Latitude',
      longitude: 'Longitude',
      dateInstall: 'Date Install',
      dateOnline: 'Date Online',
      dateOffline: 'Date Offline',
      dateAction: 'Date Last-Action',
      sim: 'SIM Code',
      router: 'Router Code',
      companyType: 'Company Type',
      companyContact: 'Contact',
      companyPhone: 'Phone',
      companyEmail: 'E-mail',
      comments: 'Comments',
    };

    const columnsToHide1: string[] = [
      'tsLast',
      'tsForwardLast',
      'tsCheck',
      'command1',
      'command2',
      'command3',
      'update',
      'persistent1',
      'persistent2',
      'companyId',
      'firmwareId',
      'firmwareVer',
      'firmwareFile',
      'typeSensorId',
      'locationId',
      'latitude',
      'longitude',
      'timeNc',
      'alarm',
      'adjusted',
      'dateInstall',
      'dateOnline',
      'dateOffline',
      'dateAction',
      'sim',
      'router',
      'comments',
      'companyType',
      'companyContact',
      'companyPhone',
      'companyEmail',
    ];
    const columnsToHide2: string[] = [
      'id',
      'tsLast',
      'tsForwardLast',
      'tsCheck',
      'command1',
      'command2',
      'command3',
      'update',
      'persistent1',
      'persistent2',
      'companyId',
      'firmwareId',
      'firmwareVer',
      'firmwareFile',
      'typeSensorId',
      'locationId',
      'timeNc',
      'alarm',
      'adjusted',
      'dateLast',
      'ipLast',
      'gatewayLast',
      'notifyNc',
      'update',
      'firmwareVer',
      'alarm',
      'alerts'
    ];
    const columnStyles: Record<string, any> = {
      id: { textAlign: 'right' },
      code: { textAlign: 'right' },
      status: { textAlign: 'center' },
      name: { textAlign: 'left' },
      description: { textAlign: 'left' },
      dateLast: { textAlign: 'center' },
      ipLast: { textAlign: 'center' },
      gatewayLast: { textAlign: 'right' },
      notifyNc: { textAlign: 'center' },
      update: { textAlign: 'center' },
      companyName: { textAlign: 'left' },
      locationName: { textAlign: 'left' },
      firmwareVer: { textAlign: 'right' },
      typeSensorName: { textAlign: 'left' },
      alarm: { textAlign: 'center' },
      adjusted: { textAlign: 'center' },
      alerts: { textAlign: 'center', type: 'abool' },
      dateInstall: { textAlign: 'center' },
      dateOnline: { textAlign: 'center' },
      dateOffline: { textAlign: 'center' },
      dateAction: { textAlign: 'center' },
      sim: { textAlign: 'left' },
      router: { textAlign: 'left' },
      companyType: { textAlign: 'left' },
      companyContact: { textAlign: 'left' },
      companyPhone: { textAlign: 'left' },
      companyEmail: { textAlign: 'left' },
      comments: { textAlign: 'left' },

      actionButtons: { textAlign: 'center' },
    };
    const selectRowProps: Record<string, string> = {
      mode: 'checkbox',
    };
    const customColumnsDefs: Record<string, any> = {
      id: {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        minWidth: 80,
        maxWidth: 80,
      },
      code: { minWidth: 80, maxWidth: 80 },
      name: { minWidth: 150, maxWidth: 150 },
      description: { minWidth: 200, maxWidth: 200 },
      status: { minWidth: 100, maxWidth: 100 },
      gatewayLast: { minWidth: 100, maxWidth: 100 },
      dateLast: { minWidth: 160, maxWidth: 160 },
      notifyNc: { cellRendererFramework: this.notifyNcCellRenderer, minWidth: 60, maxWidth: 60 },
      alerts: { cellRendererFramework: this.alertsCellRenderer },
      dateInstall: { cellRendererFramework: this.dateCellRenderer },
      dateOnline: { cellRendererFramework: this.dateCellRenderer },
      dateOffline: { cellRendererFramework: this.dateCellRenderer },
      dateAction: { cellRendererFramework: this.dateCellRenderer },
    };
    const filterTypes: Record<string, string> = {
      dateLast: 'agDateColumnFilter',
      dateInstall: 'agDateColumnFilter',
      dateOnline: 'agDateColumnFilter',
      dateOffline: 'agDateColumnFilter',
      dateAction: 'agDateColumnFilter',
    };
    return (
      <div id="content" className="content">
        <div className="row">
          <div className="col-6 wdna-padding">
            <span>
              <b>{`Total Rows Selected: ${marked}`}</b>
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button type="button" className="btn btn-info" onClick={this.showModalUpdate}>
              <b>Update</b>
            </button>
          </div>
        </div>
        <div style={{ visibility: (showGrid ? 'visible' : 'hidden') }}>
          <Table
            data={data || []}
            alias={columnAlias}
            loading={loading}
            buttons={this.buttons}
            onAdd={this.onEdit}
            onCustom={[this.onCustom1, this.onCustom2, this.onCustom3]}
            onEdit={this.onEdit}
            onGraph={this.onGraph}
            onList={this.onList}
            onDelete={this.onDelete}
            onDuplicate={this.onDuplicate}
            hiddenCols={columnsToHide1}
            rowDataChanged={this.rowDataChanged}
            customCellStyles={columnStyles}
            customColumnsDefs={customColumnsDefs}
            // TODO: review ??
            // selectRow={selectRowProps}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.countSelected}
            selection="multiple"
          />
        </div>

        <ContainerModal
          fullScreenButton={false}
          show={showSelector}
          title="Select new status"
          onClose={this.onClose1}
          modalClass="modal-small"
          footerButtons={[
            {
              text: 'Save',
              className: 'btn btn-primary',
              onClick: this.onSave,
            },
          ]}
        >
          <Select2
            name="status"
            data={[
              { id: 'ON_AIR', text: 'on-air' },
              { id: 'PLANNED', text: 'planned' },
              { id: 'DISMANTLED', text: 'dismantled' },
            ]}
            value={this.state.status}
            options={{
              placeholder: 'Status value',
            }}
            onChange={this.handleSelect}
            style={{ width: '80%' }}
          />
        </ContainerModal>

        <ContainerModal
          fullScreenButton={false}
          show={showNominal}
          title="Sensors Nominal PLan"
          modalClass="selector-modal"
          onClose={this.onClose2}
          footerButtons={[
            {
              text: 'OK',
              className: 'btn btn-primary',
              onClick: this.onClose2,
            },
          ]}
        >
          <Table
            data={data || []}
            alias={columnAlias}
            loading={loading}
            hiddenCols={columnsToHide2}
            customCellStyles={columnStyles}
            customColumnsDefs={customColumnsDefs}
            height="calc(70vh - 7px)"
            enableAdjustGridSize={false}
            filterTypes={filterTypes}
            pagination={false}
            showRowNumber
          />
        </ContainerModal>

        <ContainerModal
          fullScreenButton={false}
          show={showMigrateRegister}
          title="Migrate Register"
          onClose={this.onClose3}
          modalClass="selector-modal"
          footerButtons={[
            {
              text: 'OK',
              className: 'btn btn-primary',
              onClick: this.onClose3,
            },
          ]}
        >
          <div className="row">
            <div className="col-md-6">
              <label className="label">
                <b>Sensor 1:</b> &nbsp;
              </label>
              <Select2
                name="id_src"
                data={data.map((item: SensorListDO): DataSelect2 => {
                  return {
                    id: item.id,
                    text: `[${item.code}] ${item.name}`,
                  };
                })}
                value={id_src || ''}
                options={{
                  placeholder: 'Select option',
                }}
                onChange={this.handleChange}
                style={{ width: '90%' }}
              />
              <label>&nbsp;&nbsp;*</label>
            </div>
            <div className="col-md-6">
              <label className="label">
                <b>Sensor 2:</b> &nbsp;
              </label>
              <Select2
                name="id_dst"
                data={data.map((item: SensorListDO): DataSelect2 => {
                  return {
                    id: item.id,
                    text: `[${item.code}] ${item.name}`,
                  };
                })}
                value={id_dst || ''}
                options={{
                  placeholder: 'Select option',
                }}
                onChange={this.handleChange}
                style={{ width: '90%' }}
              />
              <label>&nbsp;&nbsp;*</label>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-6">
              <label className="label">
                <b>Date:</b> &nbsp;
              </label>
              <DatePicker
                icon
                hours={[]}
                dates={date}
                showChangeModes
                mode={flatpickrMode}
                granularity={groupDateTime}
                iconClass="wdna-ico-icon-calendar"
                handleChanges={this.handleDatePickerChanges}
                style={{ width: '80%' }}
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12">
              <b>Result: </b><br />
              <textarea
                className="inputNew"
                style={{ width: '85%', fontFamily: 'Inconsolata, monospace', fontSize: '14px' }}
                rows={15}
                cols={500}
                value={modalContent || ''}
                readOnly
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <button type="button" className="btn btn-success" onClick={(): void => { this.migrateRegisters().catch(() => { /* pass */ }); }}>
                <b>Execute</b>
              </button>
            </div>
          </div>
        </ContainerModal>
      </div>
    );
  }
}
